import { render, staticRenderFns } from "./HeadMenu.vue?vue&type=template&id=54cac439&scoped=true&"
import script from "./HeadMenu.vue?vue&type=script&lang=js&"
export * from "./HeadMenu.vue?vue&type=script&lang=js&"
import style0 from "./HeadMenu.vue?vue&type=style&index=0&id=54cac439&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cac439",
  null
  
)

export default component.exports